



























































































import { Component, Vue } from 'vue-property-decorator';
import Card from '@/components/default/Card.vue';
import machineryRentalsRepository from '@/modules/machinery/services/machineryRentalsRepository';
import notificationService from '@/services/notificationService';
import EventLogsTable from '@/modules/shared/eventlogs/components/EventLogsTable.vue';
import { DxTabs } from 'devextreme-vue';
import FileManager from '@/modules/documents/FileManager.vue';

import cPopup from '@/components/default/Popup.vue';
import {
  DxForm,
  DxSimpleItem,
  DxRequiredRule,
  DxGroupItem,
  DxLabel,
} from 'devextreme-vue/form';
import { EventLogsObjectType } from '@/modules/shared/eventlogs/enums';
import MachineryEventsTable from '@/modules/machinery/components/machineryEventsTable.vue';
import GenerateContractDialog from '@/modules/machinery/components/rental/GenerateContractDialog.vue';
import RentalInfoTable from '@/modules/machinery/components/rental/RentalInfoTable.vue';
import RentalDocumentViewer from '@/modules/machinery/components/rental/RentalDocumentViewer.vue';
import MachineryRentalEditDialog from '@/modules/machinery/components/rental/MachineryRentalEditDialog.vue';

import MachineryRentalImagesTable from '@/modules/machinery/components/MachineryRentalImagesTable.vue';
import InvoicesTable from '@/modules/invoicing/components/InvoicesTable.vue';

import SignaturePopup from '@/modules/files/components/SignaturePopup.vue';
import UploadSignedMachineryRentalContractPopup from '@/modules/machinery/components/rental/UploadSignedMachineryRentalContractPopup.vue';
import projectsRepository from '@/services/projectsRepository';

@Component({
  components: {
    GenerateContractDialog,
    RentalInfoTable,
    RentalDocumentViewer,
    MachineryRentalEditDialog,
    Card,
    cPopup,
    DxForm,
    DxSimpleItem,
    DxRequiredRule,
    DxGroupItem,
    DxLabel,
    DxTabs,
    EventLogsTable,
    MachineryEventsTable,
    MachineryRentalImagesTable,
    InvoicesTable,
    SignaturePopup,
    UploadSignedMachineryRentalContractPopup,
    FileManager,
  },
})
export default class MachineryRentalDetailPage extends Vue {
  private item: IMachineryRentalDto | null = null;
  private base64data: any = null;
  private loading: boolean = true;
  private saving: boolean = false;
  private generating: boolean = false;
  private navIndex: number = 0;
  private randomTimestamp: string = '';
  private showGenerateInvoiceDialog: boolean = false;

  private generateInvoiceModel: IMachineryRentalGenerateInvoiceCommand = {
    begin: '',
    end: '',
    rentalId: '',
    finalInvoice: false,
  };

  private mounted() {
    this.loadData();
    this.randomTimestamp = '' + new Date().getTime();

    this.generateInvoiceModel.rentalId = this.$route.params.id;
  }

  private showGenerateContractDialog() {
    (this.$refs.GenerateContractDialog as GenerateContractDialog).show();
  }

  private showSignPopup() {
    (this.$refs.SignaturePopup as SignaturePopup).open();
  }

  private showUploadSignedContract() {
    (this.$refs.UploadSignedMachineryRentalContractPopup as UploadSignedMachineryRentalContractPopup).open();
  }

  private openEditDialog() {
    (this.$refs.MachineryRentalEditDialog as MachineryRentalEditDialog).show();
  }

  private async sign(e: any) {
    try {
      (this.$refs.SignaturePopup as SignaturePopup).saving = true;

      await machineryRentalsRepository.sign(this.$route.params.id, e.blob);

      if (this.item) {
        this.item.signedContractDocumentId = 'something';
      }

      (this.$refs.SignaturePopup as SignaturePopup).hide();
      this.reloadContract();
    } catch (error) {
      notificationService.showErrorMessage('Er is iets misgelopen met het tekenen');
    } finally {
      (this.$refs.SignaturePopup as SignaturePopup).saving = false;
    }
  }

  private async removeSignedDocument() {
    try {
      await machineryRentalsRepository.RemoveSignedContract(this.$route.params.id);
      if (this.item) {
        this.item.signedContractDocumentId = '';
      }
      this.reloadContract();
    } catch (error) {
      notificationService.showErrorMessage('Er is iets misgelopen met het verwijderen van de getekende versie');
    }
  }

  private async generateInvoice() {
    try {
      this.generating = true;
      const invoice = (await machineryRentalsRepository.generateInvoice(this.generateInvoiceModel)).data;
      this.$router.push({ path: `/invoices/${invoice.id}` });
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.generating = false;
    }
  }

  private async softRefresh() {
    try {
      this.item = (await machineryRentalsRepository.getSingle(this.$route.params.id)).data;
      setTimeout(() => {
        this.reloadContract();
      }, 200);
    } catch {
      // nothing
    }
  }

  private async loadData() {
    try {
      this.loading = true;
      this.item = (await machineryRentalsRepository.getSingle(this.$route.params.id)).data;
      this.generateInvoiceModel.begin = this.item.lastInvoicedDate ? this.item.lastInvoicedDate : this.item.begin;
      this.generateInvoiceModel.end = this.item.end ? this.item.end : '';
      this.generateInvoiceModel.rentalId = this.item.id;
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.loading = false;
    }
  }

  private reloadContract() {
    (this.$refs.RentalDocumentViewer as RentalDocumentViewer).reload();
  }


  get hasSignedContract() {
    if (this.item && this.item.signedContractDocumentId && this.item.signedContractDocumentId !== '') {
      return true;
    }
    return false;
  }

  get historyConfig(): IEventLogQuery {
    return {
      objectId: (this.item as IMachineryRentalDto).id,
      type: EventLogsObjectType.MachineryRental,
    };
  }

  get navbarItems() {
    const self = this;
    return [
      { icon: 'fas fa-file-signature', text: 'Contract'},
      { icon: 'fas fa-file', text: 'Bestanden'},
      { icon: 'fas fa-bell', text: 'Events'},
      { icon: 'fas fa-file-pdf', text: 'Facturen'},
      { icon: 'fas fa-history', text: 'Geschiedenis'},
    ];
  }

  get generateInvoiceFields() {
    return [
      {
        itemType: 'simple',
        dataField: 'begin',
        editorOptions: { width: '100%', useMaskBehavior: true },
        editorType: 'dxDateBox',
        label: {
          text: 'Begin',
        },
        validationRules: [
          {type: 'required', message: 'Veld is verplicht'},
        ],
      },
      {
        itemType: 'simple',
        dataField: 'end',
        editorOptions: { width: '100%', useMaskBehavior: true },
        editorType: 'dxDateBox',
        label: {
          text: 'Einde',
        },
        validationRules: [
          {type: 'required', message: 'Veld is verplicht'},
        ],
      },
      {
          itemType: 'simple',
          dataField: 'finalInvoice',
          editorType: 'dxCheckBox',
          label: {
            text: 'Slotfactuur',
          },
      },
    ];
  }
}
